<template>
  <div class="flex w-full justify-center overflow-hidden">
    <Stepper :value="internalValue" :linear="isLinear" class="w-full overflow-hidden" @update:value="onStepSelect">
      <template v-if="isVertical">
        <template v-for="(step, zeroBasedStepIndex) in steps" :key="zeroBasedStepIndex">
          <StepItem :value="zeroBasedStepIndex + 1">
            <Step :value="zeroBasedStepIndex + 1">{{ step.label }}</Step>
            <StepPanel v-slot="{ activateCallback }" :value="zeroBasedStepIndex + 1">
              <slot :name="`panel-${step.value}`" :activate="activateCallback" />
            </StepPanel>
          </StepItem>
        </template>
      </template>
      <template v-else>
        <StepList>
          <Step v-for="(step, zeroBasedStepIndex) in steps" :key="zeroBasedStepIndex" :value="zeroBasedStepIndex + 1">
            {{ step.label }}
          </Step>
        </StepList>

        <StepPanels>
          <StepPanel
            v-for="(step, zeroBasedStepIndex) in steps"
            :key="zeroBasedStepIndex"
            v-slot="{ activateCallback }"
            :value="zeroBasedStepIndex + 1"
          >
            <slot :name="`panel-${step.value}`" :activate="activateCallback" />
          </StepPanel>
        </StepPanels>
      </template>
    </Stepper>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number">
import Step from "primevue/step";
import StepItem from "primevue/stepitem";
import StepList from "primevue/steplist";
import StepPanel from "primevue/steppanel";
import StepPanels from "primevue/steppanels";
import Stepper from "primevue/stepper";
import { computed } from "vue";
import { useBreakPoint } from "../common/utils/breakpoints";

interface Step {
  value: T;
  label: string;
}

interface Props {
  steps: Step[];
  isLinear?: boolean;
  isVertical?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isLinear: false,
});

const modelValue = defineModel<T>();

const internalValue = computed(() => {
  const index = props.steps.findIndex((stepItem) => stepItem.value === modelValue.value);
  return index !== -1 ? index + 1 : 1;
});

const isDesktopView = useBreakPoint("md");
const isVertical = computed(() => {
  if (props.isVertical === true) {
    return true;
  }

  if (isDesktopView.value) {
    return false;
  }
  return true;
});

function onStepSelect(selectedStepIndex: number) {
  const selectedStep = props.steps[selectedStepIndex - 1];

  if (selectedStep) {
    modelValue.value = selectedStep.value;
  }
}
</script>
